import { Component, inject, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-success',
  imports: [
    MatIcon
  ],
  templateUrl: './success.html',
  styleUrl: './success.scss'
})
export class Success implements OnInit {
  readonly route = inject(ActivatedRoute);
  title = 'We’ve received your payment information.';
  message = 'Please note it won’t be charged until your application is approved. You can log in and preview the site while we verify your account.';

  ngOnInit() {
   const mode = this.route.snapshot.queryParams['mode'];
   if (mode === '1') {
     this.title = 'Great news!';
     this.message = 'Your account activation is complete! You now have full access. Log in and start downloading music right away.';
   }
  }
}
